module.exports = __webpack_public_path__ + "img/mb1.2dd3fc7d.png";